// extracted by mini-css-extract-plugin
export var Section = "CorporateGovernance-module--Section--q+RSo";
export var LangHY = "CorporateGovernance-module--LangHY--f74f7";
export var ItemDesc = "CorporateGovernance-module--ItemDesc--N8fb7";
export var FileLink = "CorporateGovernance-module--FileLink--zd5-v";
export var FileDescription = "CorporateGovernance-module--FileDescription--4xmP0";
export var Header = "CorporateGovernance-module--Header--lTZcd";
export var Title = "CorporateGovernance-module--Title--nODd7";
export var Desc = "CorporateGovernance-module--Desc--YPMUt";
export var Items = "CorporateGovernance-module--Items--nAQuC";
export var Item = "CorporateGovernance-module--Item--M4UaL";
export var ItemWrapper = "CorporateGovernance-module--ItemWrapper--RQpqm";
export var ItemImage = "CorporateGovernance-module--ItemImage--MOhmj";
export var ItemContent = "CorporateGovernance-module--ItemContent--eA6cI";
export var ItemTitle = "CorporateGovernance-module--ItemTitle--0eP1Y";
export var ItemFooter = "CorporateGovernance-module--ItemFooter---P6NC";
export var FilesSection = "CorporateGovernance-module--FilesSection--NZow1";
export var MoreLessBtn = "CorporateGovernance-module--MoreLessBtn--RGvi8";
export var FileItem = "CorporateGovernance-module--FileItem--CVXkU";
export var FileInfo = "CorporateGovernance-module--FileInfo--S3fpd";
export var FileBtn = "CorporateGovernance-module--FileBtn--TtrCB";
export var IconRightWrap = "CorporateGovernance-module--IconRightWrap--P0Glr";
export var arrowLeft = "CorporateGovernance-module--arrowLeft--6t2gO";
export var arrowRight = "CorporateGovernance-module--arrowRight--OBgh7";